import {
  HOME,
  REGISTER,
  LOGOUT,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SEND_EMAIL,
  PASSWORD_RESET,
  RESET_PASSWORD_SUCCESS,
} from 'constants/routes';

/**
 * Non-returnable paths — redirecting here after auth would cause
 * confusing UX (e.g., immediate logout, password reset pages).
 */
const NON_RETURNABLE_PATHS = [HOME, REGISTER, LOGOUT, FORGOT_PASSWORD, FORGOT_PASSWORD_SEND_EMAIL, PASSWORD_RESET, RESET_PASSWORD_SUCCESS];

/**
 * Validates a return path from location.state.from.
 * Returns the sanitized path or null if invalid.
 *
 * Guards against:
 * - Open redirect via protocol-relative URLs (//)
 * - Backslash-based browser quirks (\)
 * - URL-encoded variants (%2F%2F, %5C)
 * - Non-returnable internal paths (logout, password reset)
 */
export const validateReturnPath = (path: string | undefined | null): string | null => {
  if (!path) return null;
  if (!path.startsWith('/')) return null;

  // Strip query string and hash before security checks
  const pathOnly = path.split('?')[0].split('#')[0];

  if (pathOnly.includes('//')) return null;
  if (pathOnly.includes('\\')) return null;

  const lowerPathOnly = pathOnly.toLowerCase();
  if (lowerPathOnly.includes('%2f%2f')) return null;
  if (lowerPathOnly.includes('%5c')) return null;

  // Case-insensitive blocklist check; skip HOME ('/')  — handled by exact match
  if (pathOnly === HOME) return null;
  const nonHomePaths = NON_RETURNABLE_PATHS.filter(p => p !== HOME);
  if (nonHomePaths.some(p => lowerPathOnly === p.toLowerCase() || lowerPathOnly.startsWith(p.toLowerCase() + '/'))) return null;

  return path;
};
